// extracted by mini-css-extract-plugin
module.exports = {"key-message":"styles_key-message__1YwrJ","tag":"styles_tag__3kPJp"};